import React,{ useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Typography, CircularProgress, Button, Table, TableHead,
  TableRow, TableCell, TableBody,Tooltip,Box
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { showAlert } from '../../store/slices/alertSlice'; // Update path as needed
import { useLoadDetails } from './loads.hooks';

import { constants } from '../../constants';
import BarcodeReaderIcon from '@mui/icons-material/BarcodeReader';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import UpdateBarcode from './UpdateBarcode';
function LoadDetailsPopup({ loadid, open, onClose }) {
  const dispatch = useDispatch();
  const { data, isLoading,isError,error  } = useLoadDetails(
    loadid,
    open,
  );
  const [loadData, setLoadData] = useState(null);

  React.useEffect(() => {
    if (data) {
      setLoadData(data);
    }
  }, [data]);

  const handleBarcodeUpdate = (itemId, newBarcode) => {
    setLoadData((prev) => {
      const updatedDetails = prev.load_details.map((item) =>
        item.id === itemId ? { ...item, barcode: newBarcode } : item
      );
      return { ...prev, load_details: updatedDetails };
    });
  };
  if(isError)
    {
      dispatch(
        showAlert({
          severity: constants.ERROR,
          title: error?.message || 'Failed to load details.',
        })
      );
    }
  

   
    const [selectedItem, setSelectedItem] = useState(null);
    const [childPopupOpen, setChildPopupOpen] = useState(false);
    const [popupMode, setPopupMode] = useState(''); // camera or scanner
    const handleOpenChildPopup = (item, mode) => {
      setSelectedItem(item);
      setPopupMode(mode); // set mode here
      setChildPopupOpen(true);
    };
  
    const handleCloseChildPopup = () => {
      setChildPopupOpen(false);
      setSelectedItem(null);
    };

  return (
<>
{selectedItem && (
  <UpdateBarcode
    item={selectedItem}
    open={childPopupOpen}
    onClose={handleCloseChildPopup}
    loadid={loadid}
    onBarcodeUpdate={handleBarcodeUpdate}
    mode={popupMode}
  />
)}

    <Dialog item={selectedItem} open={open} onClose={onClose} 
    maxWidth={false}
    fullWidth
    slotProps={{
      paper: {
        sx: {
          width: '100%',
          maxWidth: '100%',
        },
      },
    }}
    >
      <DialogTitle>Load #{loadid} - Product Details</DialogTitle>
      <DialogContent dividers>
        {isLoading ? (
          <CircularProgress />
        ) : !loadData ? (
          <Typography>No product data found for this load.</Typography>
        ) : (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Product Code</TableCell>
                <TableCell>Name</TableCell>
                <TableCell sx={{ textAlign: 'right' }}>Price</TableCell>
                <TableCell>Quantity</TableCell>
                <TableCell>Sold Quantity</TableCell>
                <TableCell>Vanstock Quantity</TableCell>
                <TableCell >Box Number</TableCell>
                <TableCell sx={{ textAlign: 'right' }}>Barcode</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
            {loadData.load_details.map((item) => (
                <TableRow key={item.id}>
                  <TableCell sx={{ width: 100 }}>{item.productcode}</TableCell>
                  <TableCell>{item.name}</TableCell>
                  <TableCell sx={{ textAlign: 'right' }}>€ {item.price}</TableCell>
                  <TableCell>{item.quantity}</TableCell>
                  <TableCell>{item.salesquantity}</TableCell>
                  <TableCell>{ item.quantity- item.salesquantity}</TableCell>
                  <TableCell>{item.boxnumber}</TableCell>
                  <TableCell>

  <Box display="flex" justifyContent="flex-end" gap={1} mt={0.5}>
  {item.barcode}
    {/* Camera Barcode Update */}
                  <Tooltip title="Change Barcode">
      <Button
        variant="text"
        onClick={() => handleOpenChildPopup(item, constants.BARCODE_SCAN_MODE.CAMERA)}
        sx={{ minWidth: 0 }}
      >
        <CameraAltIcon />
    </Button>
    </Tooltip>

    {/* Barcode Scanner Update */}
    <Tooltip title="Update Barcode using Scanner">
      <Button
        variant="text"
        onClick={() => handleOpenChildPopup(item, constants.BARCODE_SCAN_MODE.SCANNER)}
        sx={{ minWidth: 0 }}
      >
        <BarcodeReaderIcon />
      </Button>
    </Tooltip>
  </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">Close</Button>
      </DialogActions>
    </Dialog>
    </>
  );
}

export default LoadDetailsPopup;
